import { CommonModule, NgOptimizedImage } from '@angular/common';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Router, RouterLink } from '@angular/router';
import { NgxSpinnerModule, NgxSpinnerService } from "ngx-spinner";
import { LoginService } from './login.service';
import { HttpClient } from '@angular/common/http';
import { MyHeader } from '../config/myHeader';
import { environment } from '../../environments/environment';
import { ToastrService } from 'ngx-toastr';
import { CorrectEmailCode } from '../utils/CorrectEmailCode';
import { GenericToastrService } from '../generic-components/generic-toastr/generic-toastr.service';


@Component({
  selector: 'app-login',
    standalone: true,
  imports: [    CommonModule,
    MatCardModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule,
    MatDialogModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatIconModule,
    MatToolbarModule,
    NgxSpinnerModule,
    MatDividerModule,
    NgOptimizedImage,
    MatDialogModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent implements OnInit{
bgPath = 'assets/images/main.jpeg';
  //ogoPath = '../../favicon.png';
  constructor(
    private router: Router,
    private loginService: LoginService,
    private toastr: GenericToastrService,
    private http: HttpClient,
    private dialog: MatDialog,
    private spinner: NgxSpinnerService
  ) {
  }

  formBuilder: FormBuilder = new FormBuilder();

  correctEmailCode: CorrectEmailCode = new CorrectEmailCode();
  header: MyHeader = new MyHeader();

  async ngOnInit(): Promise<void> {
      console.log('help');
      
      const userJson = this.getCookie('user');
      if (userJson) {
        const user = JSON.parse(userJson);
        console.log('User récupéré après délai :', user);
      }

    if (['/login', '/'].includes(window.location.pathname)) {
      // Get a reference to the last interval + 1
      const interval_id = window.setInterval(function () {},
      Number.MAX_SAFE_INTEGER);

      // Clear any timeout/interval up to that id
      for (let i = 1; i < interval_id; i++) {
        window.clearInterval(i);
      }
    }

    await this.loginService.isAlreadyAuthentificated();
  }

  formLogin = this.formBuilder.group({
    username: ['', [Validators.required]],
    password: ['', [Validators.required]],
  });

  login() {
    this.spinner.show();

    localStorage.clear();
    let login : any = this.formLogin.getRawValue();
    this.loginService.getToken(login.username, login.password).subscribe(
      (res: any) => {
        this.loginService.loginRefreshTokenDate = new Date();
        this.loginService.lastTokenDate = new Date();
        localStorage.setItem('token', JSON.stringify(res));
        this.toastr.openSnackBarSuccess("identification réussie !")
        this.router.navigateByUrl('/accueil');
        this.spinner.hide();

        // this.http
        //   .get(
        //     `${environment.urlBackend}user/search?query=username=${login.username}&page=0&size=999&orderBy=id=ASC`,
        //     { headers: this.header.getHeader() }
        //   )
        //   .subscribe((res: any) => {
        //     localStorage.setItem('user', JSON.stringify(res.content[0]));
        //     this.spinner.hide();
        //     this.router.navigateByUrl('/accueil');
        //   }, (error: any) => {
        //     this.spinner.hide();
        //     this.openSnackBarProblem(
        //   "Cet utilisateur n'existe pas dans la base de données de l'applciation"
        // );
        //   });
      },
      (error : any) => {
            this.spinner.hide();

        localStorage.clear;
        this.toastr.openSnackBarProblem(
          'Votre mot de passe ou identifiant est incorrect !'
        );
      }
    );
  }

  nextLogin(seconds: any) {
    let stop = setInterval(() => {
      if (!['/login', '/'].includes(window.location.pathname)) {
        this.loginService.getNewToken().subscribe((res) => {
          this.loginService.lastTokenDate = new Date();
          localStorage.setItem('token', JSON.stringify(res));
        });
      }
    }, seconds * 1000);
  }

  public forgottenPassword() {
    /*const dialogOpen = this.dialog.open(ForgottenPasswordComponent, {
      disableClose: true,
    });
    dialogOpen.componentInstance.emailCode.subscribe((res) => {
      dialogOpen.close();
      this.changePassword(res);
    });*/

    this.toastr.openSnackBarProblem("Fonctionnalité en cours de développement !")
  }

  public changePassword(correctEmailCode: CorrectEmailCode) {
    /*const dialogOpen = this.dialog.open(ChangePasswordComponent, {
      data: {
        correctEmailCode: correctEmailCode,
      },
      disableClose: true,
    });
    dialogOpen.componentInstance.isPasswordChanged.subscribe((res) => {
      dialogOpen.close();
      this.openSnackBarSuccess('Le mot de passe a bien été changé !');
    });*/
  }

  getCookie(name: string): string | null {
    const matches = document.cookie.match(new RegExp(
      `(?:^|; )${name.replace(/([.$?*|{}()[]\\\/+^])/g, '\\$1')}=([^;]*)`
    ));
    return matches ? decodeURIComponent(matches[1]) : null;
  }

}
